import React from 'react';
import '../../styles/Layout/TopBar.css';

const TopBar = () => {
  return (
    <div className="top-bar d-none d-md-block">
      <div className="container">
        <div className="top-bar-content">
          <div className="top-bar-left">
            <i className="bi bi-envelope"></i>
            <span>info@pentagraminfotechtechnologies.com</span>
            {/*<i className="bi bi-telephone ms-3"></i>
            <span>+91-9876543210</span>*/}
          </div>
          <div className="top-bar-right">
            <span className="follow-us">Follow Us:</span>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;